import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {NextIcon} from '@modifi/ui'

import Link from '../../features/common/link'
import {ctaMapping as defaultCtaMapping} from '../constants'

const linkComponentPropTypes = {
  type: PropTypes.string.isRequired,
  targetUrl: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  openInNewTab: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  ctaMapping: PropTypes.any,
}
const linkComponentDefaultProps = {
  ctaMapping: defaultCtaMapping,
}

export type LinkComponentProps = InferPropTypes<
  typeof linkComponentPropTypes,
  typeof linkComponentDefaultProps
>

const LinkComponent: React.FC<LinkComponentProps> = ({
  targetUrl,
  type,
  label,
  openInNewTab,
  ctaMapping,
}) => {
  const CtaComponent = type ? ctaMapping[type] : null
  if (CtaComponent) {
    return (
      <Link
        data-target={targetUrl}
        type="button"
        buttonComponent={CtaComponent}
        to={targetUrl}
        targetBlank={openInNewTab}
        isTransparent={type === 'link'}
        icon={type === 'link'}
      >
        {label}
        {type === 'link' && <NextIcon height={16} width={16} />}
      </Link>
    )
  }
  return null
}

LinkComponent.propTypes = linkComponentPropTypes

LinkComponent.defaultProps = linkComponentDefaultProps

export default LinkComponent
